import { render } from "./MonthYearEditor.vue?vue&type=template&id=521b2b53"
import script from "./MonthYearEditor.vue?vue&type=script&lang=js"
export * from "./MonthYearEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__